"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalNegotiationMeetingSummary = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const file_upload_entity_1 = require("./file-upload.entity");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_quote_entity_1 = require("./opportunity-quote.entity");
const insurer_participation_entity_1 = require("./insurer-participation.entity");
const final_negotiation_participants_entity_1 = require("./final-negotiation-participants.entity");
let FinalNegotiationMeetingSummary = class FinalNegotiationMeetingSummary {
    constructor(id, meetingDate, startTime, endTime, heldAt, minutesOfMeeting, policyPlacedTypeLid, leadInsurerId, onlyLeadPaysCommissionLid, finalisedQuoteId, wouldChangeQuoteValuesLid, otherComments, variations, serviceLevelAgreementDaysLid, documentId, createdAt, updatedAt, createdBy, updatedBy) {
        this.id = id;
        this.meetingDate = meetingDate;
        this.startTime = startTime;
        this.endTime = endTime;
        this.heldAt = heldAt;
        this.minutesOfMeeting = minutesOfMeeting;
        this.policyPlacedTypeLid = policyPlacedTypeLid;
        this.leadInsurerId = leadInsurerId;
        this.onlyLeadPaysCommissionLid = onlyLeadPaysCommissionLid;
        this.finalisedQuoteId = finalisedQuoteId;
        this.wouldChangeQuoteValuesLid = wouldChangeQuoteValuesLid;
        this.otherComments = otherComments;
        this.variations = variations;
        this.serviceLevelAgreementDaysLid = serviceLevelAgreementDaysLid;
        this.documentId = documentId;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.FinalNegotiationMeetingSummary = FinalNegotiationMeetingSummary;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_date", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], FinalNegotiationMeetingSummary.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "start_time", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], FinalNegotiationMeetingSummary.prototype, "startTime", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "end_time", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], FinalNegotiationMeetingSummary.prototype, "endTime", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "held_at", type: "varchar", length: 100 }),
    tslib_1.__metadata("design:type", String)
], FinalNegotiationMeetingSummary.prototype, "heldAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "minutes_of_meeting", type: "text" }),
    tslib_1.__metadata("design:type", String)
], FinalNegotiationMeetingSummary.prototype, "minutesOfMeeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_placed_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "policyPlacedTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_insurer_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "leadInsurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "only_lead_pays_commission_lid",
        type: "int",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "onlyLeadPaysCommissionLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "finalised_quote_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "finalisedQuoteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "would_change_quote_values_lid",
        type: "int",
    }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "wouldChangeQuoteValuesLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "other_comments", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "otherComments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "variations", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "variations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "service_level_agreement_days_lid",
        type: "int",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "serviceLevelAgreementDaysLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], FinalNegotiationMeetingSummary.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], FinalNegotiationMeetingSummary.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationMeetingSummary.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "policy_placed_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "policyPlacedType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_quote_entity_1.OpportunityQuote),
    (0, typeorm_1.JoinColumn)({ name: "finalised_quote_id" }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "finalisedQuote", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationMeetingSummary.prototype, "document", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => insurer_participation_entity_1.InsurerParticipants, (participation) => participation.meetingSummary),
    tslib_1.__metadata("design:type", Array)
], FinalNegotiationMeetingSummary.prototype, "insurerShares", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => final_negotiation_participants_entity_1.FinalNegotiationParticipant, (participant) => participant.meetingSummary),
    tslib_1.__metadata("design:type", Array)
], FinalNegotiationMeetingSummary.prototype, "participants", void 0);
exports.FinalNegotiationMeetingSummary = FinalNegotiationMeetingSummary = tslib_1.__decorate([
    (0, typeorm_1.Entity)("final_negotiation_meeting_summary"),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, String, String, Number, Object, Number, Number, Number, Object, Object, Object, Object, typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object, typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object, Number, Number])
], FinalNegotiationMeetingSummary);
